import { createContext, Dispatch } from 'react'

import { UserAction } from './actions'
import { UserState } from './types'

export const UserContext = createContext<UserState | undefined>(undefined)
export const UserDispatchContext = createContext<Dispatch<UserAction> | undefined>(undefined)
